import React, { useState } from "react";

import Button from "src/components/Button/Button";
import Checkbox from "src/components/Checkbox/Checkbox";

import styles from "../JudgeScheduleBuilder.module.scss";

export interface JudgeOption {
  id: string;
  label: string;
}

interface IProps {
  judges: JudgeOption[];
  onPick: (judgeResourceId: string) => void;
  onCancel: () => void;
}

const MoveToJudgePicker: React.FC<IProps> = ({ judges, onPick, onCancel }) => {
  const [selected, setSelected] = useState(judges.length === 1 ? judges[0].id : "");

  return (
    <div className={styles.form}>
      <h3>Move to judge</h3>
      {judges.length === 0 ? (
        <div className={styles.pickerList}>
          <p className={styles.groupHint}>There are no other judges to move this class to.</p>
        </div>
      ) : (
        <div className={styles.pickerList}>
          {judges.map((judge, index) => (
            <Checkbox
              key={judge.id}
              id={`jsb-move-judge-${index}`}
              label={judge.label}
              value={selected === judge.id}
              onChange={() => setSelected(judge.id)}
            />
          ))}
        </div>
      )}
      <div className={styles.formActions}>
        <Button variant="secondary" onClick={onCancel}>Cancel</Button>
        <Button disabled={!selected} onClick={() => onPick(selected)}>Move</Button>
      </div>
    </div>
  );
};

export default MoveToJudgePicker;
